<template>
  <viewData />
</template>
<script>
import viewData from './components/viewData.vue';
export default {
  name: 'BusinessImportGeneralAdd',
  components: { viewData },
};
</script>
